// core/services/role-permission.service.ts
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface Role {
  id: number;
  designation: string;
  role_type: string;
}

export interface Action {
  id: number;
  designation: string;
  description: string;
}

export interface RolePermission {
  id: number;
  role_id: number;
  action_id: number;
  role?: Role;
  action?: Action;
}

export interface CreateRoleDto {
  designation: string;
  role_type: string;
}

export interface ActionDto {
  designation: string;
  description: string;
}

export interface AddPermissionDto {
  role_id: number;
  action_id: number;
}

@Injectable({ providedIn: 'root' })
export class RolePermissionService {
  private http = inject(HttpClient);
  private baseUrl = environment.apiUrl;

  // Roles
  getAllRoles(params?: any): Observable<any> {
    return this.http.get(`${this.baseUrl}/role-permitions`, { params });
  }

  createRole(data: CreateRoleDto): Observable<any> {
    return this.http.post(`${this.baseUrl}/role-permitions`, data);
  }

  // Permissions (Actions)
  getAllPermissions(params?: any): Observable<any> {
    return this.http.get(`${this.baseUrl}/role-permitions/actions`, { params });
  }

  createAction(data: ActionDto): Observable<any> {
    return this.http.post(`${this.baseUrl}/role-permitions/add/action`, data);
  }

  // Role Permissions
  getPermissionsByRoleId(roleId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/role-permitions/actions/role/${roleId}`);
  }

  addPermissionToRole(data: AddPermissionDto): Observable<any> {
    return this.http.post(`${this.baseUrl}/role-permitions/add-permition-to-role`, data);
  }

  removePermissionFromRole(data: AddPermissionDto): Observable<any> {
    return this.http.post(`${this.baseUrl}/role-permitions/remove-permition-to-role`, data);
  }

  // User Permissions
  getUserPermissions(userId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/role-permitions/users/${userId}`);
  }

  assignRoleToUser(userId: number, roleId: number): Observable<any> {
    return this.http.patch(`${this.baseUrl}/role-permitions/role/${roleId}`, { user_id: userId });
  }
}